import React, { Component } from "react";
// import DatePickerComponent from "react-datepicker";
import { AppMonthPicker } from "./AppMonthPicker";
import Select from "react-dropdown-select";
import AppDatePicker from "./AppDatePicker";
import AppUpload from "./AppUpload";
import AppFileUploader from "./AppFileUploader";

export class AppInput extends Component {
  constructor(props) {
    super(props);
    this.refs = {
      appinput: React.createRef(),
    };
    this.state = {
      attrs: this.attrs,
      options: []
    };
  }

  get attrs() {
    return Object.except(this.props, [
      "node",
      "className",
      "style",
      "labelClass",
      "controlClass",
      "labelpos",
      "children",
      "type",
      `dispatch`,
      `setstore`,
      `initialconstruct`,
      `navigate`,
      'onDownload',
      'onDelete'
    ]);
  }

  get options() {
    let options = this.props.options;
    if(this.state.options.length) {
        return this.state.options;
    } else if(typeof options == "string") {
        return [
            {key:"", lable:"ALL"},
            ...app.props.store[options]
        ];
    } else if(typeof options == "function") {
        let results = options(this.props);
        if(results instanceof Array && this.state.options.length==0) {
            return results;
        } else if(results instanceof Promise && this.state.options.length==0){
            results.then(data=>{
                data instanceof Array && this.setState({options:data});
            });
            return this.state.options;
        }
    } else if(options instanceof Array){
        return options;
    } else {
        return this.state.options;
    }
}

componentDidMount() {
    
    if(['select'].includes(this.props.type)) {
        let inputEle = this.refs.appinput.querySelector('.react-dropdown-select>div+input');
        inputEle && (inputEle.setAttribute('type','select'));
        let value = this.attrs.value||this.attrs.defaultValue;
        this.attrs.onData && value && this.attrs.onData(value);
        inputEle.dataset.invalue=value?.key||value;
        //console.log(inputEle.name,value);
        this.setState({
          attrs: this.attrs,
        });
    }
}

  componentDidUpdate() {
    let { attrs } = this.state;
    if(['select'].includes(this.props.type)) {
      //console.log("componentDidUpdate");
    }
    let dataset = Object.keys(this.attrs).filter(v=>v.includes('data-'));
    let attrsstatejson = Object.json(this.state.attrs,['value','defaultValue',...dataset]);
    let attrsjson = Object.json(this.attrs,['value','defaultValue',...dataset]);
    if (attrsstatejson!=attrsjson) {
      let value = this.attrs.value||this.attrs.defaultValue;
      this.attrs.onData && value && this.attrs.onData(value);
      this.setState({
        attrs: this.attrs,
      });
    }
  }

  setOption(values,attrs) {
    let inputEle = this.refs.appinput.querySelector(
      ".react-dropdown-select>div+input"
    );
    let value = values[0];
    let valkey = value?.key;
    inputEle.dataset.invalue=valkey;
    inputEle.parentElement.dataset.type = "select";
    inputEle.parentElement.dataset.value = value;
    this.props.onChange && this.props.onChange(values,value);
  }

  render() {
    let { props, state } = this;
    let { attrs } = this;
    let {
      type,
      label,
      labelClass = "col-form-label",
      selectplaceholder = "Select",
      labelpos = "top",
    } = props;
    let isText = ["text"].includes(type);
    let isSelect = ["select"].includes(type);
    let isDate = ["date"].includes(type);
    let isMonth = ["month"].includes(type);
    let isTextarea = ["textarea"].includes(type);
    let isRadio = ["radio"].includes(type);
    let isFile = ["file"].includes(type);
    let isFilePassword = ["filepassword"].includes(type);
    let isFileUploader = ["fileuploader"].includes(type);
    
    let isOthers = !(
      isText ||
      isSelect ||
      isDate ||
      isTextarea ||
      isRadio ||
      isFile ||
      isFilePassword ||
      isFileUploader ||
      isMonth
    );
    attrs.placeholder = attrs.placeholder || "Enter Here";
    attrs = Object.except(attrs, ["options"]);
    let value = (this.options || []).find(
      (opt) => opt[attrs.valueField || "key"] === (attrs.defaultValue?.key||attrs.defaultValue)
    );
    if(isSelect) {
      //console.log({value})
    }
    
    return (
      <div
        ref={"appinput"}
        className={"appinput form-group " + (props?.className || "")}
        style={props?.style || {}}
        data-input-type={type}
      >
        {labelpos == "top" && label && (
          <label className={labelClass || ""}>
            {label}
            {attrs.required && <span className="ms-1 text-warning">*</span>}
          </label>
        )}
        {isSelect && (
          <Select
            id="select"
            valueField={"key"}
            values={value ? [value] : []}
            options={this.options}
            name={attrs.name}
            className="form-control h-full"
            {...attrs}
            onChange={(values) => this.setOption(values,attrs)}
          />
        )}
        {isText && (
          <input
            className={"form-control " + (props?.controlClass || "")}
            type="text"
            {...attrs}
          />
        )}
        {isDate && (
          <AppDatePicker
            className={"form-control " + (props?.controlClass || "")}
            type={type}
            {...attrs}
          ></AppDatePicker>
        )}
        {isMonth && (
          <AppMonthPicker
            className={"form-control " + (props?.controlClass || "")}
            type={type}
            {...attrs}
          ></AppMonthPicker>
        )}
        {isOthers && (
          <input
            className={"form-control " + (props?.controlClass || "")}
            type={type}
            {...attrs}
          />
        )}
        {isTextarea && (
          <textarea
            className={"form-control " + (props?.controlClass || "")}
            type={type}
            {...attrs}
            style={{ height: "150px" }}
          ></textarea>
        )}
        {isRadio && (
          <div className="radio">
            <label htmlFor={attrs.id} className={"cursor-pointer"}>
              <input
                className={"" + (props?.controlClass || "")}
                type={type}
                {...attrs}
              />
              {props.children}
            </label>
          </div>
        )}
        {isFile && (
          <AppUpload
            className={"form-control " + (props?.controlClass || "")}
            type={type}
            {...attrs}
            onDownload={props.onDownload}
            onDelete={props.onDelete}
          >
          </AppUpload>
        )}
        {
          isFileUploader && (
            <AppFileUploader
              className={"form-control " + (props?.controlClass || "")}
              type={type}
              {...attrs}
            />
          )
        }
        {isFilePassword && (
          <AppUploadPassword
            className={"form-control " + (props?.controlClass || "")}
            type={type}
            {...attrs}
            onDownload={props.onDownload}
            onDelete={props.onDelete}
            from={"AppInput"}
          >
          </AppUploadPassword>
        )}
        {labelpos != "top" && label && (
          <label className={labelClass || ""}>
            {label}
            {attrs.required && <span className="text-danger">*</span>}
          </label>
        )}
      </div>
    );
  }
}

export default connect(AppInput);